import axios from "axios/index";
import returnUrlParams from "@/http/returnUrlParams";
import http from "@/http";
import * as types from "./types";

/**
 * This file holds actions. The actions commit mutations and can perform asynchronous operations.
 * Please refer to https://vuex.vuejs.org/guide/actions.html for more information
 */
const actions = {
  [types.GET_PRODUCT_IMAGES_BY_RECIPE](
    { rootState, commit },
    { locale, view, size, images, recipe, type = 'customizer' }
  ) {
    const requestParams = {};
    if (view) requestParams.view = view; // optionally added
    if (size) requestParams.size = size; // optionally added
    if (images) requestParams.images = images; // optionally added

    const requestUrl = `${rootState.endPoints[type].productImages}?${returnUrlParams(requestParams)}`;

    return new Promise((resolve, reject) => {
      axios({
        url: requestUrl,
        method: "POST",
        headers: { "content-type": "application/json" },
        data: JSON.stringify(recipe)
      })
        .then(({ data }) => {
          commit(types.SAVE_PRODUCT_IMAGES, data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  [types.GET_PRODUCT_IMAGES_BY_RECIPE_ID](
    { rootState },
    { recipe_id, locale, view, size, images, type = 'customizer' }) {
      const params = {};
      if (view) params.view = view; // optionally added
      if (size) params.size = size; // optionally added
      if (images) params.images = JSON.stringify(images); // optionally added

      const requestUrl = `${rootState.endPoints[type].productImages}/${recipe_id}`;

      return new Promise((resolve, reject) => {
        http
          .get(requestUrl, { params })
          .then(({ data }) => {
            resolve(data);
          })
          .catch(reject);
      });
  },

  [types.GET_CONFIRM_IMAGES](context, { recipe, images, locale }) {
    if (images) images = encodeURIComponent(JSON.stringify(images));

    const requestUrl = `${
      this.state.endPoints.customizer.confirmDesignImages
    }?images=${images}`;

    return new Promise((resolve, reject) => {
      axios({
        url: requestUrl,
        method: "POST",
        headers: { "content-type": "application/json" },
        data: JSON.stringify(recipe)
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  }
};

export default actions;
